import React from 'react'
import { Box, useTheme, Button, Typography, Stack } from "@mui/material";
import { tokens } from "../../../assets/theme";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./messages";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function MachineStopBanner(props) {
    const { stopCodeName, stopCodeColor } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    function isLight(color) {
        if (color.length === 7) {
            const rgb = [
                parseInt(color.substring(1, 3), 16),
                parseInt(color.substring(3, 5), 16),
                parseInt(color.substring(5), 16),
            ];
            const luminance =
                (0.2126 * rgb[0]) / 255 +
                (0.7152 * rgb[1]) / 255 +
                (0.0722 * rgb[2]) / 255;
            return luminance > 0.5;
        }
        return false
    }

     return (
        <Box
            sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                marginTop: "2px",
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
                direction: "row",
                backgroundColor: colors.redAccent[500],
            }}
        >
            <Stack spacing={1} direction="row" sx={{}} display="flex" alignItems="center">
                <InfoOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px', marginLeft: '20px' }}
                >
                    Maskinen stoppad: 
                </Typography>
                
                { stopCodeColor && stopCodeColor !== "" &&
                    <Box
                        display="flex"
                        borderRadius="4px"
                        justifyContent="center"
                        backgroundColor={stopCodeColor}
                        sx={{ 
                            marginLeft: '10px',
                            width: "25px",
                            height: "25px",
                            marginBottom: "3px",
                        }}
                    />
                }
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px', marginLeft: '20px' }}
                >
                    { stopCodeName }
                </Typography>

                <Box width="20px"></Box>
            </Stack>
        </Box>
    )
}